import { normalizeFieldToken } from "./audit-token-normalizers.js";

export function parsePositiveIntegerLike(value) {
  if (value === null || value === undefined) return null;
  const trimmed = String(value).trim();
  if (!/^\d+$/.test(trimmed)) return null;
  const numeric = Number(trimmed);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
}

export function resolveAuditFieldTokenForFormatting(field) {
  return normalizeFieldToken(field).replace(/-/g, "_");
}

export function isPanelAuditField(field) {
  const normalized = resolveAuditFieldTokenForFormatting(field);
  const mapped = normalized.replace(/^tabela_([^_]+)_/, "item_$1_");
  return mapped === "idpanel" || mapped.endsWith("_idpanel");
}

export function isIdClientAuditField(field) {
  const normalized = resolveAuditFieldTokenForFormatting(field);
  const mapped = normalized.replace(/^tabela_([^_]+)_/, "item_$1_");
  return (
    mapped === "id_client" ||
    mapped === "idclient" ||
    mapped.endsWith("_id_client") ||
    mapped.endsWith("_idclient")
  );
}

export function isCommissionTypeAuditField(field) {
  const normalized = resolveAuditFieldTokenForFormatting(field);
  const mapped = normalized.replace(/^tabela_([^_]+)_/, "item_$1_");
  return (
    mapped === "type_commission" ||
    mapped === "typecommission" ||
    mapped.endsWith("_type_commission") ||
    mapped.endsWith("_typecommission")
  );
}

export function isIdServiceAuditField(field) {
  const normalized = resolveAuditFieldTokenForFormatting(field);
  const mapped = normalized.replace(/^tabela_([^_]+)_/, "item_$1_");
  return mapped === "idservice" || mapped.endsWith("_idservice");
}

export function isRawBackedAuditField(field) {
  return (
    isPanelAuditField(field) ||
    isIdServiceAuditField(field) ||
    isIdClientAuditField(field) ||
    isCommissionTypeAuditField(field)
  );
}
